import { __ } from '@wordpress/i18n';
import { RawHTML, useEffect } from "@wordpress/element";
import { useBlockProps, InnerBlocks, InspectorControls, ColorPalette, MediaUpload, MediaUploadCheck } from '@wordpress/block-editor';
import { __experimentalHeading as Heading, PanelBody, ToggleControl, __experimentalUnitControl as UnitControl, RangeControl, Button, GradientPicker } from '@wordpress/components';

export const edit = ({ clientId, attributes, setAttributes }) => {

    const {
        id,
        hfcFootInnerWidth,
        hfcFootBGcolor,
        hfcFootBorderColor,
        hfcFootMenuTitlesColor,
        hfcFootMenuLinksColor,
        hfcFootMenuLinksHoverColor,
        hfcFootSocialIconsColor,
        hfcFootSocialIconsHoverColor,
        hfcHasFootBGimg,
        hfcFootBGimg,
        hfcFootBGolColor,
        hfcFootBGolRange
    } = attributes;

    useEffect(() => {
        if (!id) {
            // Set unique ID through block index only once.
            let clientIdSliced = clientId.slice(clientId.lastIndexOf("-") + 1);
            setAttributes({ id: 'hfc-footer-' + clientIdSliced });
        }
    }, [id, clientId, setAttributes]);

    // Defined Block Props.
    const blockProps = useBlockProps();
    const hfcDynamicStyles = `/*Compatable with generatePress*/
    .wp-block-group__inner-container {
        max-width: 100% !important;
        padding: 0 !important;
        margin: 0 !important;
    }
    .wpforms-container {
        margin: 0 !important;
        padding: 0 !important;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-1 a {
        text-decoration: none;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-1 a:hover {
        text-decoration: underline;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-3 .wp-block-columns  .wp-block-column:last-child figure{
        margin: 0 !important;
    }
    .wp-block-post-content.block-editor-block-list__layout {
        padding: 0;
        margin: 0;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-2 ul li button{
        background: transparent;
        border: none;
    }
    /*Compatable with Astra*/
   .editor-styles-wrapper fieldset {
        padding: 0 !important;
    }
    .editor-styles-wrapper.block-editor-writing-flow {
        margin: 0;
        padding: 0;
    }
    .ast-separate-container .edit-post-visual-editor__content-area {
        padding: 0 !important;
    }
    .editor-styles-wrapper .block-editor-block-list__block{
        max-width: 100% !important;
    }
    /*Main Css*/
    #${id} footer p{
        margin: 0;
    }
    #${id}.hfc-footer-3{
        position: relative;
        background: ${hfcFootBGcolor};
        max-width: 100% !important;
        z-index: 1;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-1 .hfc-footer-navigation-container,
    #${id}.hfc-footer-3 .hfc-footer-container-1 .hfc-navigation-item,
    #${id}.hfc-footer-3 .hfc-footer-container-1 .wp-block-navigation__container {
         display:block;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-1 .hfc-footer-navigation-container{
         margin-top: 20px;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-1,
    #${id}.hfc-footer-3 .hfc-footer-container-2,
    #${id}.hfc-footer-3 .hfc-footer-container-3{
        max-width: 100% !important;
        margin: 0;
        padding: 0;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-1{
        padding: 50px 0px;
    }
    #${id}.hfc-footer-3 .hfc-footer-col-container{
        padding-right: 40px;
        padding-left: 40px;
        max-width: 1600px;
        margin: 0 auto;
        max-width: ${hfcFootInnerWidth} !important;
    }
    #${id}.hfc-footer-3 h4{
        color: ${hfcFootMenuTitlesColor};
        font-size: 18px;
        line-height: 24px;
        font-weight: bold;
    }
    #${id}.hfc-footer-3 a.wp-block-navigation-item__content{
       color: ${hfcFootMenuLinksColor};
       opacity: 0.75;
       font-size: 14px;
       font-weight: 400;
       line-height: 25px;
       padding-bottom: 8px;
    }
    #${id}.hfc-footer-3 a.wp-block-navigation-item__content:hover{
        color: ${hfcFootMenuLinksHoverColor} !important;
    }
    #${id}.hfc-footer-3 span.hfc-footer-img-overlay {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: ${hfcFootBGolColor};
        opacity: ${hfcFootBGolRange}%;
        z-index: -1;
    }
    #${id}.hfc-footer-3 img.hfc-footer-bg-img {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: -2;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-1 p ,
    #${id}.hfc-footer-3 .hfc-footer-container-3 p {
        color: #fff;
        opacity: 0.75;
        font-size: 16px;
        font-weight: 400;
        line-height: 28px;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-1 p{
        margin-top: 20px;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-2 {
        padding-bottom: 30px;
    }
    #${id}.hfc-footer-3 svg {
        fill: ${hfcFootSocialIconsColor};
    }
    #${id}.hfc-footer-3 svg:hover {
        fill: ${hfcFootSocialIconsHoverColor};
    }
    #${id}.hfc-footer-3 .wp-block-navigation .wp-block-navigation-item__content {
        display: inline-block;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-2 .wp-block-columns {
        align-items: center !important;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-2 .wp-block-columns ul{
         justify-content: end;
         gap: 10px;
         margin: 0;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-2 .wp-block-columns ul li svg {
        width: 24px;
        height:24px;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-3{
        padding: 30px 0px;
        border-top: 1px inset ${hfcFootBorderColor};
    }
    #${id}.hfc-footer-3 .hfc-footer-container-3 .hfc-footer-col-container{
        align-items: center !important;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-3 .wp-block-columns .wp-block-column:last-child{
        display:flex;
        justify-content: end;
    }
    #${id}.hfc-footer-3 .wp-social-link {
        background: transparent !important;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-3 a {
         text-decoration: none;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-3 a:hover{
        color: ${hfcFootMenuLinksHoverColor};
        text-decoration: underline;
    }
    #${id} .hfc-footer-sub-form .wpforms-field-label {
        display: none;
    }
    #${id} .hfc-footer-sub-form .wpforms-container .wpforms-field {
        padding: 0;
    }
    #${id} .hfc-footer-sub-form .wpforms-form {
        position: relative;
        max-width: 380px;
        margin: 0;
    }
    #${id} .hfc-footer-sub-form ::placeholder {
        color: #fff !important;
    }
    #${id} .hfc-footer-sub-form .wpforms-submit-container {
        position: absolute;
        top: 0;
        right: 0;
        margin: 0 !important;
        padding: 0px;
    }
    #${id} .hfc-footer-sub-form .wpforms-submit-container .wpforms-submit:focus::after{
        border: none;
    } 
    #${id} .hfc-footer-sub-form input {
        max-width: 100% !important;
        background: transparent !important;
        border: 1px solid #fff !important;
        color: #fff !important;
        border-radius: 50px !important;
        padding-left: 20px !important;
    }
    #${id} .hfc-footer-sub-form [type=submit] {
        background: transparent !important;
        padding: 5px 20px !IMPORTANT;
        margin: 1px;
        border-left: 1px solid #fff !important;
        border-radius: 50px !important;
    }
    #${id} .hfc-footer-cr-txt a {
        color: #fff;
    }
    #${id} .hfc-footer-sub-form input:focus,
    #${id} .hfc-footer-sub-form input:active {
        border-radius: 50px !important;
        box-shadow: 0 0 0 calc(1px + 1px)rgba(255, 255, 255, 0.5) !important;
        outline: 0;
    }`;
    const TEMPLATE = [
        [
            'core/group', { tagName: 'footer' },
            [
                [
                    'core/group',
                    { className: 'hfc-footer-container-1' },
                    [
                        [
                            'core/columns',
                            { className: 'hfc-footer-col-container' },
                            [
                                [
                                    'core/column',
                                    { className: '' },
                                    [
                                        ['core/heading', {
                                            content: 'SUPPORT',
                                            level: 4
                                        }],
                                        ['core/navigation', {
                                            className: 'hfc-footer-navigation-container',
                                            overlayMenu: 'never'
                                        }, [
                                                ['core/navigation-link', {
                                                    label: 'Shipping and Return',
                                                    url: '#',
                                                    rel: 'nofollow',
                                                    className: 'hfc-navigation-item'
                                                }],
                                                ['core/navigation-link', {
                                                    label: 'Privacy Policy',
                                                    url: '#',
                                                    rel: 'nofollow',
                                                    className: 'hfc-navigation-item'
                                                }],
                                                ['core/navigation-link', {
                                                    label: 'Contact Us',
                                                    url: '#',
                                                    rel: 'nofollow',
                                                    className: 'hfc-navigation-item'
                                                }],
                                                ['core/navigation-link', {
                                                    label: 'Site Map',
                                                    url: '#',
                                                    rel: 'nofollow',
                                                    className: 'hfc-navigation-item'
                                                }]
                                            ]]
                                    ]
                                ],
                                [
                                    'core/column',
                                    { className: '' },
                                    [
                                        ['core/heading', {
                                            content: 'MAIN MENU',
                                            level: 4
                                        }],
                                        ['core/navigation', {
                                            className: 'hfc-footer-navigation-container',
                                            overlayMenu: 'never'
                                        }, [
                                                ['core/navigation-link', {
                                                    label: 'Home',
                                                    url: '#',
                                                    rel: 'nofollow',
                                                    className: 'hfc-navigation-item'
                                                }],
                                                ['core/navigation-link', {
                                                    label: 'Shop',
                                                    url: '#',
                                                    rel: 'nofollow',
                                                    className: 'hfc-navigation-item'
                                                }],
                                                ['core/navigation-link', {
                                                    label: 'Explore Avalanche',
                                                    url: '#',
                                                    rel: 'nofollow',
                                                    className: 'hfc-navigation-item'
                                                }],
                                                ['core/navigation-link', {
                                                    label: 'Downloads',
                                                    url: '#',
                                                    rel: 'nofollow',
                                                    className: 'hfc-navigation-item'
                                                }]
                                            ]]
                                    ]
                                ],
                                [
                                    'core/column',
                                    { className: '' },
                                    [
                                        ['core/heading', {
                                            content: 'ABOUT US',
                                            level: 4
                                        }],
                                        [
                                            'core/paragraph', { content: 'Avalanche is the fastest smart contracts platform in the blockchain industry, as measured by time-to-finality. Avalanche is blazingly fast, low cost, and eco-friendly. Any smart contract-enabled application can outperform its competition by deploying on Avalanche.' }
                                        ]
                                    ]
                                ],
                            ]
                        ]
                    ]
                ],
                [
                    'core/group',
                    { className: 'hfc-footer-container-2' },
                    [
                        [
                            'core/columns', { className: 'hfc-footer-col-container' }, [
                                [
                                    'core/column', { className: 'hfc-footer-sub-form' },
                                    [
                                        ['core/heading', {
                                            content: 'JOIN THE COMMUNITY',
                                            level: 4
                                        }],
                                        ['wpforms/form-selector', {}]
                                    ]
                                ],
                                [
                                    'core/column', { className: '' },
                                    [
                                        ['core/social-links', { className: '' }, [
                                            ['core/social-link', {
                                                service: 'x',
                                                url: '#'
                                            }],
                                            ['core/social-link', {
                                                service: 'facebook',
                                                url: '#'
                                            }],
                                            ['core/social-link', {
                                                service: 'linkedin',
                                                url: '#'
                                            }],
                                            ['core/social-link', {
                                                service: 'pinterest',
                                                url: '#'
                                            }]
                                        ]]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ],
                [
                    'core/group',
                    { className: 'hfc-footer-container-3' },
                    [
                        [
                            'core/columns', { className: 'hfc-footer-col-container' }, [
                                [
                                    'core/column', { className: 'hfc-footer-cr-txt' },
                                    [['core/paragraph', {
                                        content: '© 2024 <a href="#">Your Company Name</a>. <a href="#">Powered By Your company Name</a>'
                                    }]]
                                ],
                                [
                                    'core/column', { className: 'hfc-footer-sponsor-logo' },
                                    [
                                        ['core/image', {
                                            url: require('../../public/img/trust-badge-trimed.png'),
                                            className: 'hfc-footer-site-about-logo'
                                        }]
                                    ],

                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ]
    ];
    return ([
        <InspectorControls key={`inspector-controls-${id}`}>
            <PanelBody
                title={__('Cross Rating Block Settings')}
                icon={'admin-generic'}
                initialOpen={true}
                className={'frhd__control frhd__control-query'}
            >
                <UnitControl
                    label={__('Footer Inner Width :')}
                    onChange={newValue => setAttributes({ hfcFootInnerWidth: newValue })}
                    isUnitSelectTabbable
                    value={hfcFootInnerWidth}
                    className={'frhd__component frhd__component-width-90'}
                />
                <Heading className={'frhd__pb-heading'}>Footer Background Color :</Heading>
                <GradientPicker
                    value={hfcFootBGcolor}
                    onChange={(colorValue) => setAttributes({ hfcFootBGcolor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Footer Border Color :</Heading>
                <ColorPalette
                    value={hfcFootBorderColor}
                    onChange={(colorValue) => setAttributes({ hfcFootBorderColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Menu Titles Color :</Heading>
                <ColorPalette
                    value={hfcFootMenuTitlesColor}
                    onChange={(colorValue) => setAttributes({ hfcFootMenuTitlesColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Menu Items Color :</Heading>
                <ColorPalette
                    value={hfcFootMenuLinksColor}
                    onChange={(colorValue) => setAttributes({ hfcFootMenuLinksColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Menu Items Hover Color :</Heading>
                <ColorPalette
                    value={hfcFootMenuLinksHoverColor}
                    onChange={(colorValue) => setAttributes({ hfcFootMenuLinksHoverColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Social Icons Color :</Heading>
                <ColorPalette
                    value={hfcFootSocialIconsColor}
                    onChange={(colorValue) => setAttributes({ hfcFootSocialIconsColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Social Icons Hover Color :</Heading>
                <ColorPalette
                    value={hfcFootSocialIconsHoverColor}
                    onChange={(colorValue) => setAttributes({ hfcFootSocialIconsHoverColor: colorValue })}
                    clearable={false}
                />
                <ToggleControl
                    label={
                        hfcHasFootBGimg
                            ? 'Footer Background Image :'
                            : 'Footer Background Image :'
                    }
                    checked={hfcHasFootBGimg}
                    onChange={newValue => setAttributes({ hfcHasFootBGimg: newValue })}
                    __nextHasNoMarginBottom
                    className={'frhd__component-diff'}
                />
                    {hfcHasFootBGimg && (
                    <>
                        <Heading className={'frhd__pb-heading'}>Footer Background Image :</Heading>
                        <img src={hfcFootBGimg} className={'frhd__pb-media-upload-preview'} />
                        <MediaUploadCheck>
                            <MediaUpload
                                onSelect={(media) =>
                                    setAttributes({ hfcFootBGimgObj: media.sizes, hfcFootBGimg: media.sizes.full.url })
                                }
                                allowedTypes={['image']}
                                value={hfcFootBGimg}
                                render={({ open }) => (
                                    <Button
                                        onClick={open}
                                        icon={'admin-media'}
                                        className={'frhd__gr-media-btn button button-secondary'}
                                    >Open Media Library</Button>
                                )}
                            />
                        </MediaUploadCheck>
                        <Heading className={'frhd__pb-heading'}>Footer Overlay Color :</Heading>
                        <ColorPalette
                            value={hfcFootBGolColor}
                            onChange={(colorValue) => setAttributes({ hfcFootBGolColor: colorValue })}
                            clearable={false}
                        />
                        <RangeControl
                            label={'Footer Overlay Opacity :'}
                            value={hfcFootBGolRange}
                            onChange={(colorValue) => setAttributes({ hfcFootBGolRange: colorValue })}
                            min={0}
                            max={100}
                            __nextHasNoMarginBottom
                        />
                    </>
                )}
            </PanelBody>
        </InspectorControls>,
        <div {...blockProps} key={`${id}-main-blocks`}>
            <RawHTML>{`<style>${hfcDynamicStyles}</style>`}</RawHTML>
            <div id={id} className={'hfc-footer-3'}>
                {hfcHasFootBGimg && (
                    <>
                        <span className='hfc-footer-img-overlay'></span>
                        <img src={hfcFootBGimg} className='hfc-footer-bg-img' />
                    </>
                )}
                <InnerBlocks template={TEMPLATE} />
            </div>
        </div>
    ])
}

export const save = ({ attributes }) => {

    const {
        id,
        hfcFootInnerWidth,
        hfcFootBGcolor,
        hfcFootBorderColor,
        hfcFootMenuTitlesColor,
        hfcFootMenuLinksColor,
        hfcFootMenuLinksHoverColor,
        hfcFootSocialIconsColor,
        hfcFootSocialIconsHoverColor,
        hfcHasFootBGimg,
        hfcFootBGimg,
        hfcFootBGolColor,
        hfcFootBGolRange
    } = attributes;

    const hfcDynamicStyles = `
    #${id}.hfc-footer-3{
        position: relative;
        background: ${hfcFootBGcolor};
        max-width: 100% !important;
        z-index: 1;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-1 a:hover {
        text-decoration: underline;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-1 .hfc-footer-navigation-container,
    #${id}.hfc-footer-3 .hfc-footer-container-1 .hfc-navigation-item,
    #${id}.hfc-footer-3 .hfc-footer-container-1 .wp-block-navigation__container {
         display:block;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-1 .hfc-footer-navigation-container{
         margin-top: 20px;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-1,
    #${id}.hfc-footer-3 .hfc-footer-container-2,
    #${id}.hfc-footer-3 .hfc-footer-container-3{
        max-width: 100% !important;
        margin: 0;
        padding: 0;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-1{
        padding: 50px 0px;
    }
    #${id}.hfc-footer-3 .hfc-footer-col-container{
        padding-right: 40px;
        padding-left: 40px;
        max-width: 1600px;
        margin: 0 auto;
        max-width: ${hfcFootInnerWidth};
    }
    #${id}.hfc-footer-3 h4{
        color: ${hfcFootMenuTitlesColor};
        font-size: 18px;
        line-height: 24px;
        font-weight: bold;
    }
    #${id}.hfc-footer-3 a.wp-block-navigation-item__content{
       color: ${hfcFootMenuLinksColor};
       opacity: 0.75;
       font-size: 14px;
       font-weight: 400;
       line-height: 25px;
       padding-bottom: 8px;
    }
    #${id}.hfc-footer-3 a.wp-block-navigation-item__content:hover{
        color: ${hfcFootMenuLinksHoverColor} !important;
    }
    #${id}.hfc-footer-3 span.hfc-footer-img-overlay {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: ${hfcFootBGolColor};
        opacity: ${hfcFootBGolRange}%;
        z-index: -1;
    }
    #${id}.hfc-footer-3 img.hfc-footer-bg-img {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: -2;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-1 p ,
    #${id}.hfc-footer-3 .hfc-footer-container-3 p {
        color: #fff;
        opacity: 0.75;
        font-size: 16px;
        font-weight: 400;
        line-height: 28px;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-1 p{
        margin-top: 20px;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-2 {
        padding-bottom: 30px;
    }
    #${id}.hfc-footer-3 svg {
        fill: ${hfcFootSocialIconsColor};
    }
    #${id}.hfc-footer-3 svg:hover {
        fill: ${hfcFootSocialIconsHoverColor};
    }
    #${id}.hfc-footer-3 .wp-block-navigation .wp-block-navigation-item__content {
        display: inline-block;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-2 .wp-block-columns {
        align-items: center !important;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-2 .wp-block-columns ul{
         justify-content: end;
         gap: 10px;
         margin: 0;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-2 .wp-block-columns ul li svg {
        width: 24px;
        height:24px;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-3{
        padding: 30px 0px;
        border-top: 1px inset ${hfcFootBorderColor};
    }
    #${id}.hfc-footer-3 .hfc-footer-container-3 .hfc-footer-col-container{
        align-items: center !important;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-3  .wp-block-columns  .wp-block-column:last-child{
        display:flex;
        justify-content: end;
    }
    #${id}.hfc-footer-3 .wp-social-link {
        background: transparent !important;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-3 a {
         text-decoration: none;
    }
    #${id}.hfc-footer-3 .hfc-footer-container-3 a:hover{
        color: ${hfcFootMenuLinksHoverColor};
        text-decoration: underline;
    }
    #${id} .hfc-footer-sub-form .wpforms-field-label {
        display: none;
    }
    #${id} .hfc-footer-sub-form .wpforms-container .wpforms-field {
        padding: 0;
    }
    #${id} .hfc-footer-sub-form .wpforms-form {
        position: relative;
        max-width: 380px;
        margin: 0;
    }
    #${id} .hfc-footer-sub-form ::placeholder {
        color: #fff !important;
    }
    #${id} .hfc-footer-sub-form .wpforms-submit-container {
        position: absolute;
        top: 0;
        right: 0;
        margin: 0 !important;
        padding: 0px;
    }
    #${id} .hfc-footer-sub-form .wpforms-submit-container .wpforms-submit:focus::after{
        border: none;
    }
    #${id} .hfc-footer-sub-form input {
        max-width: 100% !important;
        background: transparent !important;
        border: 1px solid #fff !important;
        color: #fff !important;
        border-radius: 50px !important;
        padding-left: 20px !important;
    }
    #${id} .hfc-footer-sub-form [type=submit] {
        background: transparent !important;
        padding: 5px 20px !IMPORTANT;
        margin: 1px;
        border-left: 1px solid #fff !important;
        border-radius: 50px !important;
    }
    #${id} .hfc-footer-cr-txt a {
        color: #fff;
    }
    #${id} .hfc-footer-sub-form input:focus,
    #${id} .hfc-footer-sub-form input:active{
        border-radius: 50px !important;
        box-shadow: 0 0 0 calc(1px + 1px)rgba(255, 255, 255, 0.5) !important;
        outline: 0;
    }
    @media(max-width:781px){
        #${id}.hfc-footer-3 .hfc-footer-col-container .wp-block-column{
           flex-basis: unset!important;
        }
        #${id}.hfc-footer-3 .hfc-footer-container-2 {
            padding-bottom: 25px;
        }
        #${id}.hfc-footer-3 .hfc-footer-sub-form .wpforms-form {
            margin: 0 auto !important;
        }
        #${id}.hfc-footer-3 .hfc-footer-container-2 .wp-block-columns ul {
            justify-content: center !important;
        }
        #${id}.hfc-footer-3 .hfc-footer-container-3 .wp-block-columns .wp-block-column:last-child {
            justify-content: center;
        }
        #${id}.hfc-footer-3 .hfc-footer-container-3 > .wp-block-columns {
            flex-direction: column-reverse !important;
        }
        #${id}.hfc-footer-3 .hfc-footer-container-3 p {
            text-align: center;
        } 
      }
        @media(max-width: 599px){
            footer {
            text-align: center;
        }
        .hfc-footer-3 .hfc-footer-container-2 .wp-block-columns ul {
            justify-content: center !important;
        }
        .hfc-footer-3 .hfc-footer-container-3 > .wp-block-columns > .wp-block-column:last-child {
            display: block !important;
        }
        }
        `;
    return (
        <>
            <RawHTML>{`<style>${hfcDynamicStyles}</style>`}</RawHTML>
            <div id={id} className={'hfc-footer-3'}>
                 {hfcHasFootBGimg && (
                    <>
                        <span className='hfc-footer-img-overlay'></span>
                        <img src={hfcFootBGimg} className='hfc-footer-bg-img' />
                    </>
                  )}
                <InnerBlocks.Content />
            </div>
        </>
    )
}